module.exports = __webpack_public_path__ + "static/media/brand-icons.e8c322de.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/brand-icons.woff2
// module id = ./src/styling/theme/assets/fonts/brand-icons.woff2
// module chunks = 0